import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import checkmarkImg from "../images/checkmark.b8187469.svg"
import arrowForwardImg from "../images/arrow-forward.svg"
import $ from 'jquery';
import moment from 'moment';
import { secUser, guidance, database } from '../firebase'
export default class AssesmentApply extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checkboxFlag: false,
      checkBoxValue: '',
      expertiseFlag : false,
      skillFlag:false,
      budgetData:[],
      modeOfLearningData:[],
      expertiseData:[],
      skillData:[]
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeChk = this.handleChangeChk.bind(this);
    this.handleDropDownChange = this.handleDropDownChange.bind(this)
  }
  async componentDidMount(){
    let budgetList = [];
    let expertiseList=[];
    let skillList = []
    let modeOfLearningList = []
    await database.ref("modeOfLearning").once('value',function(snapshot){
        snapshot.forEach(function(ChildSnapshot){
            if(ChildSnapshot.val().status == 'Active'){
              modeOfLearningList.push({
                modeOfLearning:ChildSnapshot.val().modeOfLearning                      
                });
            }
        });
    });
    this.setState({
      modeOfLearningData:modeOfLearningList
    });
    await database.ref("priceRange").once('value',function(snapshot){
        snapshot.forEach(function(ChildSnapshot){
            if(ChildSnapshot.val().status == 'Active'){
              budgetList.push({
                    priceRange:ChildSnapshot.val().priceRange
                });
            }
        });
    });
    this.setState({
        budgetData:budgetList
    });
    await database.ref("expertise").once('value',function(snapshot){
      snapshot.forEach(function(ChildSnapshot){
          if(ChildSnapshot.val().status == 'Active'){
              expertiseList.push({
                  expertise:ChildSnapshot.val().expertise
              });
          }
      });
  });
  this.setState({
      expertiseData:expertiseList
  });
      let userExpertise = localStorage.getItem("userExpertise")
      await database.ref("skills").once('value',function(snapshot){
        snapshot.forEach(function(ChildSnapshot){
            if(ChildSnapshot.val().status == 'Active' && ChildSnapshot.val().expertise == userExpertise){
              skillList.push({
                    skill:ChildSnapshot.val().skill
                });
            }
        });
    });
    this.setState({
        skillData:skillList
    });
    this.renderList()
  }
  renderList() {
       let data=JSON.parse(localStorage.getItem("guidanceArray"))   
    console.log(data)
    $("#goal").val(data.goal)
    
    //$("#education").val(data.Education)
    //$("#resumeLink").val(data.resumeLink)
    this.setState({
      goal: data.goal,
      checkboxFlag: true,
      expertiseFlag:false,
      skillFlag:false,
      checkBoxValue:''
    });
    this.handleChangeChkFilling(data.isItFromTheCurrentExpertise)
   // this.setState({expertise:data.Expertise,experience:data.Experience,education:data.Education,resumeLink:data.resumeLink})
   $("#expertise").val(data.Expertise)
   $("#priceRange").val(data.budgetConstriction)
   $("#modeOfLearning").val(data.modeOfLearning)
   this.setState({     
   checkBoxValue:data.isItFromTheCurrentExpertise,
    expertise:data.goalExpertise,
    skill:data.goalSkill,
    priceRange:data.budgetConstriction,
    modeOfLearning:data.modeOfLearning,
   });
   }
   handleChangeChkFilling (value) {
    let isChecked = value;
    if(isChecked == "No" && this.state.goal == "1"  ){
      this.setState({
        expertiseFlag:true
      })
    }
    else{
      this.setState({
        expertiseFlag:false
      })
    }
    if(isChecked == "No" && this.state.goal == "2"){
      this.setState({
        skillFlag:true
      })
    }
    else{
      this.setState({
        skillFlag:false
      })
    }
    if(this.state.goal == "3" || this.state.goal == "4"){
      this.setState({
        skillFlag:false,
        expertiseFlag:false
      })
    }
    
    this.setState({
      checkBoxValue: isChecked
    });
  }
  handleDropDownChange = (event)=>{
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    })
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
      checkboxFlag: true,
      expertiseFlag:false,
      skillFlag:false,
      checkBoxValue:''
    });
  };
  handleChangeChk = (e) => {
    let isChecked = e.target.value;
    if(isChecked == "No" && this.state.goal == "1"  ){
      this.setState({
        expertiseFlag:true
      })
    }
    else{
      this.setState({
        expertiseFlag:false
      })
    }
    if(isChecked == "No" && this.state.goal == "2"){
      this.setState({
        skillFlag:true
      })
    }
    else{
      this.setState({
        skillFlag:false
      })
    }
    if(this.state.goal == "3" || this.state.goal == "4"){
      this.setState({
        skillFlag:false,
        expertiseFlag:false
      })
    }
    
    this.setState({
      checkBoxValue: isChecked
    });
  }
  updateData() {
    let progressInfo=parseInt(localStorage.getItem("progressInfo"));
    if(this.state.modeOfLearning!=""){ progressInfo=progressInfo+10}
    if(this.state.budgetConstriction!=""){ progressInfo=progressInfo+5}
    if(this.state.goal!=""){ progressInfo=progressInfo+5}
    localStorage.setItem("progressInfo",progressInfo)
    const dataSet = {     
      goal:this.state.goal?this.state.goal:"",
      isItFromTheCurrentExpertise:this.state.checkBoxValue?this.state.checkBoxValue:"",
      goalExpertise:this.state.expertise?this.state.expertise:"",
      goalSkill:this.state.skill?this.state.skill:"",
      budgetConstriction:this.state.priceRange?this.state.priceRange:"",
      modeOfLearning:this.state.modeOfLearning?this.state.modeOfLearning:"",
      progressInfo:progressInfo
    }
    database.ref(`Guidance/${this.props.match.params.key}`).update(dataSet).then(() => {
      localStorage.setItem("userGoalExpertise",this.state.expertise ? this.state.expertise: "")
        window.location.href = "/assesment/apply-4/id="+this.props.match.params.key       
  
    }).catch(() => {
        alert("Somthing went wrong")
    })
    //window.location.href = "/assesment/apply-4"
  }
  render() {
    return (
      <div className="main-wrapper assesment-wrapper">
        <Header></Header>
        <div className="main-content" style={{ background: "#f4f6f9" }}>
          <div className="container p-0 pt-5">
            <div className='row'>
              <div className='col-lg-6 m-auto p-0'>
                <form className='form-main-wrapper'>
                  <div className='form-group progress-det'>
                    <span className='progress-content'>Step 3/5 : Goals</span>
                    <div className="progress">
                      <div className="progress-bar" role="progressbar" style={{ width: "60%" }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="form-group">
                    <label for="goal">Goals</label>
                    <div className='row'>
                      <select className="form-control" id="goal" name="goal" onChange={this.handleChange}>
                        <option value="0">Select Goal</option>
                        <option value="1">Do you want to acquire a new skill?</option>
                        <option value="2">Do you want to upskill yourself?</option>
                        <option value="3">Are you looking for a certificate?</option>
                        <option value="4">Are you looking for a specific institute?</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                  
                    {this.state.checkboxFlag == true &&
                    
                      <div className='row' onChange={this.handleChangeChk}>
                        <label for="goal">Is it from the current expertise?</label>
                        <label for="goalChk" className="label-radio" style={{ width: "100px" }}>
                          <input checked={this.state.checkBoxValue === "Yes"} name="goalChk" id="goalChk" type="radio" value="Yes" />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>Yes</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                        <label for="goalChk" className="label-radio" style={{ width: "100px" }}>
                          <input checked={this.state.checkBoxValue === "No"} name="goalChk" id="goalChk" type="radio" value="No" />
                          <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                          <span>No</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                      </div>
                    }
                  </div>
                  {this.state.expertiseFlag &&
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Expertise </label>
                    {/* <input type="text" className="form-control" name="Expertise" id="Expertise" onChange={this.handleChange}/> */}
                    <select className="form-control" onChange={this.handleDropDownChange} id="expertise" name="expertise">
                                              <option key="">Select Expertise</option>
                                            {
                                                this.state.expertiseData.map( (x,y) => 
                                                  <option key={x.expertise} value={x.expertise}>{x.expertise}</option> )
                                              }</select>
                  </div>
  }
   {this.state.skillFlag &&
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Skills </label>
                    {/* <input type="text" className="form-control" name="Expertise" id="Expertise" onChange={this.handleChange}/> */}
                    <select className="form-control" onChange={this.handleDropDownChange} id="skill" name="skill">
                                              <option key="">Select Skill</option>
                                            {
                                                this.state.skillData.map( (x,y) => 
                                                  <option key={y}>{x.skill}</option> )
                                              }</select>
                  </div>
  }
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Budget Constriction </label>
                    {/* <input type="text" className="form-control" name="Expertise" id="Expertise" onChange={this.handleChange}/> */}
                    <select className="form-control" onChange={this.handleDropDownChange} id="priceRange" name="priceRange">
                                              <option key="">Select Budget Constriction</option>
                                            {
                                                this.state.budgetData.map( (x,y) => 
                                                  <option key={y}>{x.priceRange}</option> )
                                              }</select>
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Mode of learning</label>
                    {/* <input type="text" className="form-control" name="Expertise" id="Expertise" onChange={this.handleChange}/> */}
                    <select className="form-control" onChange={this.handleDropDownChange} id="modeOfLearning" name="modeOfLearning">
                                              <option key="">Select Mode of learning</option>
                                            {
                                                this.state.modeOfLearningData.map( (x,y) => 
                                                  <option key={y}>{x.modeOfLearning}</option> )
                                              }</select>
                  </div>
                  <div className="form-group mt-4">
                    <a href="#" className="btn btn-gray w-100" onClick={() => this.updateData()}>
                      Next <img src={arrowForwardImg} className="arrow-filter"></img>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ivano/assesment-apply3.jsx